import React, { useEffect } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';

export default function Toast({ message, type = 'success', onClose, duration = 4000 }) {
  useEffect(() => {
    if (message && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [message, duration, onClose]);

  if (!message) return null;

  return (
    <div className="fixed top-6 right-6 z-[9999] animate-fade-in-slide shadow-2xl rounded-xl">
      <div className={`flex items-center gap-3 p-4 pr-5 rounded-xl border backdrop-blur-md
        ${type === 'success' 
          ? 'bg-[#6B8F71] border-[#527056] text-white' 
          : 'bg-rose-500 border-rose-700 text-white'}`}
      >
        {type === 'success' ? <CheckCircle size={20} className="text-white/90" /> : <XCircle size={20} className="text-white/90" />}
        <span className="font-medium text-sm tracking-wide">{message}</span>
        <button onClick={onClose} className="ml-4 p-1 hover:bg-black/10 rounded-full transition-colors">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
